import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LAND_ROLE_FEATURE_KEY, LandRoleState } from './land-role.reducer';
import { clientLandRoleEntity } from './land-role.models';

export const selectLandRoleState = createFeatureSelector<LandRoleState>(LAND_ROLE_FEATURE_KEY);

export const selectLandRole = createSelector(selectLandRoleState, (state: LandRoleState) => state.landRole);

export const selectAllCountriesAndRoles = createSelector(selectLandRole, (entity: clientLandRoleEntity | null) => {
  const countries = new Map<string, string>();
  const roles = new Map<string, string>();

  if (entity) {
    entity.countries.forEach((c) => countries.set(c.id, c.name));
    entity.roles.forEach((r) => roles.set(r.id, r.name));
  }
  return {
    countries: Array.from(countries, ([id, name]) => ({ id, name })).sort((a, b) =>
      (a.name ?? '').localeCompare(b.name ?? '')
    ),
    roles: Array.from(roles, ([id, name]) => ({ id, name: name ?? '' })),
  };
});
